import {
  Vertrag,
  VertragZahlungsmethode,
} from '@/domain/vertraege/shared/types/vertrag';
import { useTranslation } from 'react-i18next';

export function PreisInfo({ vertrag }: { vertrag: Vertrag }) {
  const { t } = useTranslation();
  const defaultZahlungsmethode =
    vertrag.vertragZahlungsmethode === VertragZahlungsmethode.SEPA
      ? 'Sepa-Lastschrift'
      : vertrag.vertragZahlungsmethode === VertragZahlungsmethode.UEBERWEISUNG
      ? 'Überweisung'
      : 'Unbekannt';

  const formatSummeNetto = vertrag.summeNetto.wert
    .toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
    .replace(/\./g, '');

  return (
    <div className="flex flex-col items-end justify-end w-full">
      <div className="text-xs text-neutrals-700">
        {t('domain.vertraege.slide.taxInfo')}
      </div>
      <span className="text-xs text-neutrals-700">
        {t('domain.vertraege.slide.tax')}
      </span>
      <div className="flex pb-2 justify-end font-bold gap-2">
        <span className="flex top-0 -mt-1 text-xl align-top font-semibold">
          {t('general.currency.EUR')}
        </span>
        <span className="flex text-2xl">{formatSummeNetto}</span>
      </div>
      <div className="text-xs text-neutrals-700 uppercase">
        {defaultZahlungsmethode}
      </div>
    </div>
  );
}
